import { useMutation } from '@apollo/client'
import { ExportTestSession, ExportTestSessionVariables } from '../../types'
import { EXPORT_TEST_SESSION } from './operations'

export const useExportTestSession = () =>
  useMutation<ExportTestSession, ExportTestSessionVariables>(EXPORT_TEST_SESSION)
